"use client";

import type { MetricProps } from "@/components/shared/metric";
import { Metric } from "@/components/shared/metric";
import { useNumberCounter } from "@/hooks/use-number-counter";

interface AnimatedMetricProps extends MetricProps {
  value: number;
  isUsd: boolean;
  numDecimals?: number;
}

const AnimatedMetric = (props: AnimatedMetricProps) => {
  const animatedValue = useNumberCounter(
    props.value,
    props.numDecimals,
    props.isUsd,
  );

  return <Metric {...props} value={animatedValue} />;
};

export default AnimatedMetric;
